import api from '../../plugins/api';

// Убирает присланный клиентом документ вида kind (все его загрузки по сделке).
const deleteClientUploadFile = ({ dealId, kind }) => {
  return api.post('/api/crm/clientUpload/deleteFile', { dealId, kind });
};

export default deleteClientUploadFile;
